// Values must match the backend EDevopsJobTitle enum exactly; the label mirrors
// the value verbatim because the backend expects the enum string. Keep this list
// in sync with the Workforce provisioning contract (see NDSI-204).
export const JOB_TITLES = [
  'athlete',
  'next',
  'specialist',
  'lead',
  'admin_assistant',
  'coach',
  'assistant_head_coach',
  'head_coach',
  'dos',
  'support',
].map((v) => ({ label: v, value: v }));

export const MAX_STORES = 10;

export const MAX_STORES_MESSAGE = 'You can select up to 10 stores at a time.';

// TODO: NDSI-185 - replace with the real Confluence KB URL once the article is published.
export const KB_URL = '#';
